import {
  addMonthsToIsoDate,
  getLocalIsoDate,
} from './monitoringScheduleDateUtils';

import type IScheduleConfigDraft from '../interfaces/IScheduleConfigDraft';

const createDefaultScheduleConfigDraft = (): IScheduleConfigDraft => {
  const startDate = getLocalIsoDate();

  return {
    mode: 'recurring',
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York',
    recurrence: {
      frequency: 'weekly',
      interval: 1,
      daysOfWeek: ['MO', 'TH'],
      timeOfDay: '08:00:00',
      startDate,
      endDate: addMonthsToIsoDate(startDate, 5),
    },
    noEndDate: false,
    agentConfigId: null,
    autoCreateImpactScenario: false,
    impactScenarioMinSeverity: null,
  };
};

export default createDefaultScheduleConfigDraft;
